<template>
    <div class="solution">
        <h2>我们的移动互联网 <br/>产品解决方案</h2>
        <div class="title-con">
            <div class="item">APP开发</div>
            <div class="item">小程序开发</div>
            <div class="item">web开发</div>
            <div class="item">电商社交</div>
            <div class="item">智慧餐饮</div>
            <div class="item">教育行业</div>
            <div class="item">零售行业</div>
            <div class="item">O2O解决⽅案</div>
        </div>
        <div class="title">随着移动互联技术的不断成熟，丰富的营销玩法和互动方式让用户逐渐呈现更多主动性和依赖性，企业与用户的交流也更加便捷。我们通过定制App解决方案帮助企业覆盖更多相关用户场景，持续获得流量增长，实现商业价值的整合转换。</div>

        <div class="cons">
            <div class="item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/29.png" />
                <div class="name">IOS</div>
            </div>
            <div class="item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/31.png" />
                <div class="name">安卓</div>
            </div>
            <div class="item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/33.png" />
                <div class="name">⽤户粘性</div>
            </div>
            <div class="item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/35.png" />
                <div class="name">品牌互动</div>
            </div>
            <div class="item">
                <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs/37.png" />
                <div class="name">表现形式</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped lang="scss">
    .solution{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 51px;
        box-sizing: border-box;
        width: 1200px;
        margin:0 auto 0;
        // background: #781BFF;
        h2{
            font-size: 34px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000B33;
            line-height: 51px;
            text-align: center;
        }
        .title-con{
            display: flex;
            align-items: center;
            gap: 83px;
            margin-top:76px;
            .item{
                font-size: 15px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 21px;
            }
        }
        .title{
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
            line-height: 21px;
            text-align: center;
            margin-top: 76px;
            width: 947px;
        }
        .cons{
            display: flex;
            align-items: center;
            gap: 96px;
            margin-top:37px;
            .item{
                display: flex;
                flex-direction: column;
                align-items: center;
                img{
                    width: 114px;
                    height: 114px;
                }
                .name{
                    font-size: 17px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #212529;
                    line-height: 24px;
                }
            }
        }
    }
</style>